import heroBannerFull from "../assets/images/OurServices/Banner Full - 19 - 1920_1080.webp";
import aboutUs from "../assets/images/OurServices/About Us -2 - 1280_720.webp";
import ourVision from "../assets/images/OurServices/Our Vision - 2 - 1080_1080.webp";
import ourApproach from "../assets/images/OurServices/Our Approach - 2 - 1080_1080.webp";
import ourPromise from "../assets/images/OurServices/Our Promise - 2 - 1080_1080.webp";
import ourStrengths from "../assets/images/OurServices/Our Strengths - 2 - 1080_1080.webp";
import ourExpertiseHeader from "../assets/images/OurServices/Our Expertise - 3 - 1290_720.webp";
import corporateEvent from "../assets/images/OurServices/Corporate Event - 2 - 1080_1080.webp";
import socialEvent from "../assets/images/OurServices/Social Event - 3 - 1080_1080.webp";
import publicEvent from "../assets/images/OurServices/Public Event - 1280_720.webp";
import bannerHalf from "../assets/images/Home/Wedding Planning - 2 - 1080_1080.webp";
import experiencedProfessionals from "../assets/images/OurServices/Experienced Industry Professionals - 8 - 1080_1080.webp";
import strategicPlanning from "../assets/images/OurServices/Strategic Planning Approach - 9 - 1080_1080.webp";
import creativeSolutions from "../assets/images/OurServices/Creative & Customized Solutions - 8 - 1080_1080.webp";
import endToEnd from "../assets/images/OurServices/End-To-End Event Management - 11 - 1080_1080.webp";
import qualityTechnical from "../assets/images/OurServices/Quality & Technical Excellence - 5 - 1080_1080.webp";
import clientSatisfaction from "../assets/images/OurServices/Client Satisfaction First - 6 - 1080_1080.webp";
import affordablePrice from "../assets/images/OurServices/Affordable Price - 12 - 1080_1080.webp";
import howWeWorkBanner from "../assets/images/OurServices/Banner - How Are We Working - Half - 12 - 1280_360.webp";
import researchPlanning from "../assets/images/OurServices/Research & Planning - 11 - 1080_1080.webp";
import creativeConcept from "../assets/images/OurServices/Creative Concept Development - 1 - 1080_1080.webp";
import coordinationExecution from "../assets/images/OurServices/Coordination & Execution - 9 - 1080_1080.webp";
import onGround from "../assets/images/OurServices/On-Ground Management - 6 - 1080_1080.webp";
import qualityDelivery from "../assets/images/OurServices/Quality Control & Delivery - 9 - 1080_1080.webp";

export const homeImages = {
  heroBannerFull,
  aboutUs,
  visionApproach: {
    "Our Vision": ourVision,
    "Our Approach": ourApproach,
    "Our Promise": ourPromise,
    "Our Strengths": ourStrengths,
  },
  ourExpertiseHeader,
  expertise: {
    "Corporate Event": corporateEvent,
    "Wedding Planning": bannerHalf,
    "Social Event": socialEvent,
    "Public Event": publicEvent,
  },
  whyChooseUs: {
    "Experienced Industry Professionals": experiencedProfessionals,
    "Strategic Planning Approach": strategicPlanning,
    "Creative & Customized Solutions": creativeSolutions,
    "End-To-End Event Management": endToEnd,
    "Quality & Technical Excellence": qualityTechnical,
    "Transparent & Reliable Execution": qualityDelivery,
    "Client Satisfaction First": clientSatisfaction,
    "Affordable Price": affordablePrice,
  },
  howWeWorkBanner,
  howWeWorkSteps: {
    2: researchPlanning,
    3: creativeConcept,
    4: coordinationExecution,
    5: onGround,
    6: qualityDelivery,
  },
};
